import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

const EnvironmentConfigurationLandingPage = lazy(
  () =>
    import('@/pages/Configuration/environmentConfigurations/EnvrionmentConfigLandingPage'),
);
const MachineDetailsDrawer = lazy(
  () =>
    import('@/pages/Configuration/environmentConfigurations/components/drawer/MachineDetailsDrawer'),
);
const NavigateToInstanceModal = lazy(
  () =>
    import('@/pages/Configuration/environmentConfigurations/components/modal/NavigateToInstanceModal'),
);
const AccessDetailsDrawer = lazy(
  () =>
    import('@/pages/Configuration/environmentConfigurations/components/drawer/AccessDetailsDrawer'),
);
const ImpactListDrawer = lazy(
  () =>
    import('@/pages/Configuration/environmentConfigurations/components/drawer/impactList/ImpactListDrawer'),
);
const ChangeDefaultMachineModal = lazy(
  () =>
    import('@/pages/Configuration/environmentConfigurations/components/modal/ChangeDefaultMachineModal'),
);
const DisableMachineModal = lazy(
  () =>
    import('@/pages/Configuration/environmentConfigurations/components/modal/disableMachineModal'),
);

export const EnvironmentConfigurationRoutes: RouteObject[] = [
  {
    path: '/configuration/environment-configuration/*',
    element: <EnvironmentConfigurationLandingPage />,
    children: [
      {
        path: 'machine-details/:clientId',
        element: <MachineDetailsDrawer />,
        children: [
          {
            path: 'navigate-to-instance',
            element: <NavigateToInstanceModal />,
          },
        ],
      },
      {
        path: 'machine-details/:clientId/navigate-to-instance/:selectedPlugIn',
        element: <NavigateToInstanceModal />,
      },
      {
        path: 'access-details/:hostName/:machineId',
        element: <AccessDetailsDrawer />,
      },
      {
        path: 'impact-list-drawer/:value/:machineName/:clientId',
        element: <ImpactListDrawer />,
      },
      {
        path: 'change-default-machine',
        element: <ChangeDefaultMachineModal />,
      },
      {
        path: 'disable-machine',
        element: <DisableMachineModal />,
      },
    ],
  },
];
